module.exports = __webpack_public_path__ + "static/media/EHS-Daily-Log-Recording-Procedure.47c1b0de.pdf";